import { styled } from "@material-ui/core";

export const Body = styled('div')(()=>({
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    width: '100%',
    height: '50%',
    backgroundColor: 'rgb(35, 35, 35)',
    zIndex: 2000,
    borderRadius: '20px 20px 0px 0px',
    padding: '15px',
    boxSizing: 'border-box',
    '& .reactGiphySearchbox-componentWrapper': {
        width: '100% !important',
    },
    overflowY: 'auto'
}))

export const MenuSearchInput = styled('input')(({ theme }) => ({
    width: '100%',
    height: '40px',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '10px',
    padding: '0px 10px',
    outline: 'none !important',
    border: '1px solid rgba(0, 0, 0, .5)',
    color: '#fff',
    marginBottom: '10px',
    boxSizing: 'border-box'
}))
